import React from 'react';
import { useApiClient } from "../../base/hooks/useApiClient";
import { useAsyncRetry } from "react-use";
import { Page } from "../../layout/Page";
import { CreditCard, Loader2 } from 'lucide-react';
import {TransactionHistory} from "./TransactionHistory";

export function ProfileBillingPage() {
    const apiClient = useApiClient();

    const { value: balance, loading } = useAsyncRetry(async () => {
        const response = await apiClient.get('balance');
        if (!response.ok) console.error('Error fetching balance');
        const data = await response.json();
        return data.balance;
    }, [apiClient]);

    return (
        <Page>
            <div className="max-w-3xl mx-auto p-6">
                <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">Account Balance</h2>
                    <div className="flex items-center justify-between p-4 bg-indigo-50 rounded-lg">
                        <div className="flex items-center">
                            <CreditCard className="h-8 w-8 text-indigo-600 mr-3" />
                            <div>
                                <p className="text-sm text-gray-600">Current Balance</p>
                                <p className="text-2xl font-bold text-indigo-600">
                                    {loading ? (
                                        <Loader2 className="h-8 w-8 animate-spin" />
                                    ) : Number(balance).toFixed(2)}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <TransactionHistory />
            </div>
        </Page>
    );
}
